import { createFileRoute, Outlet, redirect, useRouterState } from "@tanstack/react-router";
import { VendorPortalLayout } from "@/components/vendor/VendorPortalLayout";

export const Route = createFileRoute("/vendor")({
  beforeLoad: ({ location }) => {
    const path = location.pathname;
    if (path === "/vendor" || path === "/vendor/") {
      throw redirect({ to: "/vendor/login" });
    }
  },
  head: () => ({
    meta: [
      { title: "Venue Portal · Pulse" },
      { name: "description", content: "Pulse venue partners." },
    ],
  }),
  component: VendorShell,
});

/** Public standalone child routes: rendered via <Outlet /> WITHOUT the auth-guarded
 *  VendorPortalLayout, so unauthenticated users can register / see the pending screen. */
const STANDALONE_CHILD_PATHS = new Set([
  "/vendor/login",
  "/vendor/register-venue",
  "/vendor/pending",
]);

function VendorShell() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  if (STANDALONE_CHILD_PATHS.has(pathname)) {
    return <Outlet />;
  }

  return (
    <VendorPortalLayout>
      <Outlet />
    </VendorPortalLayout>
  );
}
